module.exports = __webpack_public_path__ + "SL.png?daf195bf0464b73d7963b46bbed89653";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/SL.png
// module id = 406
// module chunks = 0